import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./theme.css";
import "./workspaces/find/find.css";
import "./screens.css";
import "./auth.css";
import "./public.css";
import "./appearance.css";
import "./mobileWorkspace98.css";
import { initializeAppearance } from "./appearance/appearance";

initializeAppearance();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
